import { render, staticRenderFns } from "./BuilderShare.vue?vue&type=template&id=4c0d9c1c&scoped=true&"
import script from "./BuilderShare.vue?vue&type=script&lang=js&"
export * from "./BuilderShare.vue?vue&type=script&lang=js&"
import style0 from "./BuilderShare.vue?vue&type=style&index=0&id=4c0d9c1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d9c1c",
  null
  
)

export default component.exports